import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { IdealPartnerProfile } from '../components/sections/IdealPartnerProfile';
export function WhoWeServe() {
  const notAFit = ['Businesses outside of D2D or direct sales.', 'Startups with zero revenue.', 'Teams looking for a "quick fix" without doing the work.', "Leaders who aren't willing to change their onboarding process.", 'Companies who treat recruiting as a temporary project.'];
  return <div className="pt-20" data-id="element-1790">
      {/* Ideal Partner Profile as Hero */}
      <IdealPartnerProfile asHero={true} data-id="element-1791" />

      {/* Not a Fit */}
      <section className="section-padding bg-gray-50" data-id="element-1792">
        <div className="container-custom" data-id="element-1793">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1794">
            <h2 className="mb-6" data-id="element-1795">Who We Are NOT For</h2>
            <p className="text-body-large leading-relaxed" data-id="element-1796">
              Let's save us both some time. If this sounds like you, we probably
              aren't a match.
            </p>
          </div>

          <div className="max-w-3xl mx-auto" data-id="element-1797">
            <div className="bg-white rounded-xl p-8 shadow-lg border-2 border-gray-200" data-id="element-1798">
              <ul className="space-y-4" data-id="element-1799">
                {notAFit.map((item, index) => <li key={index} className="flex items-start" data-id="element-1800">
                    <XCircleIcon className="h-6 w-6 text-gray-400 flex-shrink-0 mr-3 mt-0.5" data-id="element-1801" />
                    <span data-id="element-1802">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-1803">
            <p className="mb-6" data-id="element-1804">
              We don't force it. The best results come when we are perfectly
              aligned.
            </p>
            <a href="/book-call" className="inline-block bg-slate hover:bg-slate-dark text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg" data-id="element-1805">
              Schedule Your Strategy Call →
            </a>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="section-padding bg-white" data-id="element-1806">
        <div className="container-custom" data-id="element-1807">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1808">
            <h2 className="mb-6" data-id="element-1809">Sound Like You?</h2>
            <p className="text-body-large mb-8 leading-relaxed" data-id="element-1810">
              If you are a D2D leader ready to build a real system, let's have
              an honest conversation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1811">
              <a href="/book-call" className="inline-block bg-slate hover:bg-slate-dark text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg" data-id="element-1812">
                Schedule a Strategy Call →
              </a>
              <a href="/case-studies" className="inline-block border-2 border-navy text-navy hover:bg-navy hover:text-white font-bold px-8 py-4 rounded-lg transition-colors" data-id="element-1813">
                View Case Studies
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
}